import DrawerMenu_module_default from "./DrawerMenu.module.js";
import { getPlatform } from "../../utils/platform.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Menu/DrawerMenu.tsx
/**
* A menu in a drawer, as commonly seen on mobile.
*/
var DrawerMenu = forwardRef(({ title, children, className, ...props }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	className: classNames(className, DrawerMenu_module_default.drawer),
	"aria-label": title,
	"data-platform": getPlatform(),
	...props,
	role: "menu",
	children: /* @__PURE__ */ jsx("div", {
		className: DrawerMenu_module_default.body,
		children
	})
}));
DrawerMenu.displayName = "DrawerMenu";
//#endregion
export { DrawerMenu };

//# sourceMappingURL=DrawerMenu.js.map